import React, { useEffect, useRef, useState } from "react";
import MaterialTable from "material-table";
import Paper from "@material-ui/core/Paper";
import Tooltip from "@material-ui/core/Tooltip";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import { IconButton } from "@material-ui/core";
import TablePagination from "@material-ui/core/TablePagination";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import PointersLine from "../../components/Loaders/PointersLine/PointersLine";
import { Row, Col } from "react-bootstrap";
import { ReactComponent as ChevronRight } from "../../assets/svg/chevron-right-rounded.svg";
import Card from "../../components/ConfigurationCards";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import AdminEventsFilters from "../../components/AdminEventsFilters/AdminEventsFilters";
import { getStateLoginComplete } from "../LayoutHome/stateLogin";
import { useLazyQuery, useMutation } from "@apollo/client";
import InfoIcon from "@material-ui/icons/Info";
import PortalModal from "../../Portals";
import { theme as themeConfig } from "../../themes/themes";
import {
  CardsWrapperUsers,
  ContentTable,
  Convention,
  ContentFilters,
  ContentButtonSeeDetails,
  ContentRegistered,
  DetailContainer,
  ActionSection,
  TableViewButton,
  GeneralStyle,
  ModaContainer,
  ModalContent,
  TemplateContainer,
  PreviewContainer,
  PercentLabel,
  ActionsContainer,
  useStyles,
} from "./AdminEventsContainer.styled";
import {
  COUNTRIES_BY_CLIENT,
  ALL_CATEGORIES,
  LIST_EVENTS_FIRST,
  LIST_EVENTS_AFTER,
  LIST_EVENTS_BEFORE,
} from "../../GraphQL/Queries";
import {
  UPDATE_STATE_EVENT,
  CREATE_SURVEY_FOR_EVENT,
  JOIN_EVENT_WITH_SURVEY,
  APPLY_SURVEY_TEMPLATE,
} from "../../GraphQL/Mutations";
import { useHistory } from "react-router-dom";
import { clientWellness } from "../../App";
import ModalConfirmAction from "../../components/ModalConfirmAction/ModalConfirmAction";
import MenuManageEvents from "../../components/MenuManageEvents/MenuManageEvents";
import ViewControlMenu from "../../components/ViewControlMenu/ViewControlMenu";
import AdminCategoryContainer from "../AdminCategoryContainer/AdminCategoryContainer";
import ViewList from "@material-ui/icons/ViewList";
import ViewCards from "@material-ui/icons/ViewModule";
import TemplateList from "../../components/TemplateList";
import ModalTemplatePreview from "../../components/ModalTemplatePreview";
import { NotificationManager } from "react-notifications";
import ExportExcelFile from "../../components/ReportSurveyBlock/ExportExcelFile/ExportExcelFile";
import { formatDate_ddmmyy } from "../../util/UtilityFunctions";
import HeaderComponent from "../../components/Header/Header";
import { ReactComponent as CalendarIcon } from "../../assets/svg/calendar-header-icon.svg";
import { AntSwitch } from "../../helpers/antSwitch.js";
import { AntTab, AntTabs } from "../../helpers/antTabs";
import { FilterList } from "@material-ui/icons";
import SearchComponent from "../../components/SearchComponent/SearchComponent";
import { withStyles } from "@material-ui/core/styles";

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: themeConfig.neutral.gray[2500],
    color: "white",
    padding: "1em 1em 1em 0",
    border: "1px solid #dadde9",
  },
}))(Tooltip);

const AdminEventsContainer = () => {
  const classes = useStyles();
  const [UserComplete] = useState(getStateLoginComplete());
  const [value, setValue] = useState(0);
  const [selectedMenu, selectMenu] = useState(["add", "New Event"]);
  const [formTrigger, setFormTrigger] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorSelected, setAnchorSelected] = useState(null);
  const [allPages, setAllPages] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [rowsPerPageOptions] = useState([5, 10, 20]);
  const history = useHistory();
  const [data, setdata] = useState();
  const [startCursor, setStartCursor] = useState("");
  const [endCursor, setEndCursor] = useState("");
  const [showLoader, setshowLoader] = useState(false);
  const [reloadRender, setreloadRender] = useState(false);
  const [Filtered, setFiltered] = useState(false);
  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState();
  const [dataFilter, setDataFilter] = useState({});
  const [categoriesList, setcategoriesList] = useState({});
  const [openDeleteModal, setOpenDeleteModal] = useState(null);
  const [showCards, setShowCards] = useState(true);
  const [showTemplates, setShowTemplates] = useState(false);
  const [templateToPreview, setTemplateToPreview] = useState();
  const [eventSelected, setEventSelected] = useState();
  const [dataExport, setDataExport] = useState([]);
  const [nameFile, setnameFile] = useState("");
  const [showFilter, setShowFilter] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [openDescription, setOpenDescription] = useState(false);
  const rSearch = useRef();
  const rCities = useRef();

  const asignData = (data) => {
    setAllPages(data.allEventsList.totalCount);
    if (data.allEventsList.pageInfo.hasNextPage === true) {
      setEndCursor(data.allEventsList.pageInfo.endCursor);
    }
    if (data.allEventsList.pageInfo.hasPreviousPage === true) {
      setStartCursor(data.allEventsList.pageInfo.startCursor);
    }
    let allEventsList = data.allEventsList.nodes.map((element) => {
      let time = new Date(element.finishDate) - new Date(element.startDate);
      let diffDays = Math.floor(time / 86400000); // days
      let diffHrs = Math.floor((time % 86400000) / 3600000); // hours
      let diffMins = Math.round(((time % 86400000) % 3600000) / 60000); // minutes

      let progress = 0;
      let guests = "0 of 0";

      if (element.eventType == "Public" && element.participantsLimit > 0) {
        guests = `${element.wellnessParticipants.filter(
          (f) => f.attendStatus == "Accept" && f.recordState == "Active"
        ).length
          } of ${element.participantsLimit ? element.participantsLimit : 0}`;
        progress =
          (element.wellnessParticipants.filter(
            (f) => f.attendStatus == "Accept" && f.recordState == "Active"
          ).length *
            100) /
          (element.participantsLimit ? element.participantsLimit : 0);
      } else if (
        element.eventType == "Private" &&
        element.wellnessParticipants.length
      ) {
        guests = `${element.wellnessParticipants.filter(
          (f) => f.attendStatus == "Accept" && f.recordState == "Active"
        ).length
          } of ${element.wellnessParticipants.filter((f) => f.recordState == "Active")
            .length
          }`;
        progress =
          (element.wellnessParticipants.filter(
            (f) => f.attendStatus == "Accept" && f.recordState == "Active"
          ).length *
            100) /
          element.wellnessParticipants.filter((f) => f.recordState == "Active")
            .length;
      }

      let guestUsers = element.wellnessParticipants.map((user) => {
        return user.userId;
      });
      let avgRating = 0;
      let sum = 0;
      let totalRating = element.wellnessEventFeedbacks.length;
      element.wellnessEventFeedbacks.forEach((Feedback) => {
        sum += parseInt(Feedback.rating);
      });
      avgRating = sum / totalRating;
      let feedbacks = element.wellnessEventFeedbacks;
      let dto = {
        idEvent: element.idEvent,
        eventName: element.eventName,
        description: element.description,
        categoryName: element.idCategoryNavigation.categoryName,
        createDate: new Date(element.createDate).toLocaleDateString(),
        startDate: new Date(element.startDate).toLocaleString(),
        startDateFormatted: formatDate_ddmmyy(new Date(element.startDate)),
        finishDate: element.finishDate,
        duration: `${(diffDays ? " " + diffDays + "D" : "") +
          (diffHrs ? " " + diffHrs + "h" : "") +
          " " +
          diffMins +
          "m"
          }`,
        createUser: element.createUser,
        eventState: element.eventState,
        registered: element.wellnessParticipants.length,
        confirmed: parseInt(progress),
        eventType: element.eventType,
        guests: guests,
        guestUsers,
        averageRating: isNaN(avgRating) ? 0 : avgRating.toFixed(1),
        totalReviews: totalRating,
        feedbacks,
      };
      return dto;
    });
    setdata(allEventsList);
  };
  const [createSurveyForEvent] = useMutation(CREATE_SURVEY_FOR_EVENT);
  const [updateStatusevent] = useMutation(UPDATE_STATE_EVENT, {
    client: clientWellness,
  });
  const [joinEventWithSurvey] = useMutation(JOIN_EVENT_WITH_SURVEY, {
    client: clientWellness,
  });
  const [applyTemplate] = useMutation(APPLY_SURVEY_TEMPLATE);
  const [runEventsFirst, { loading: loadingEvents }] = useLazyQuery(
    LIST_EVENTS_FIRST,
    {
      client: clientWellness,
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        asignData(data);
        setshowLoader(false);
      },
    }
  );

  const [runEventsAfter] = useLazyQuery(LIST_EVENTS_AFTER, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      asignData(data);
      setshowLoader(false);
    },
  });
  const [runEventsBefore] = useLazyQuery(LIST_EVENTS_BEFORE, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      asignData(data);
      setshowLoader(false);
    },
  });

  const [runQueryGetCategories] = useLazyQuery(ALL_CATEGORIES, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let resultCategories = data.allCategories.map((element) => {
        return {
          value: element?.idCategory,
          label: element?.categoryName,
        };
      });
      setcategoriesList(resultCategories);
    },
  });

  const [runQueryCountry, { loading: loadingCountries }] = useLazyQuery(
    COUNTRIES_BY_CLIENT,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        let resultOfCountries = data.countryLocationList.map((element) => {
          return {
            ...element,
            value: element?.countryId,
            label: element?.countryName,
          };
        });
        setCountries(resultOfCountries);
      },
    }
  );

  const getCityForCountry = (id) => {
    let selectedCountry = countries.filter((e) => e.countryId === parseInt(id));
    if (selectedCountry?.length > 0) {
      let citiesArr = selectedCountry[0].cities.map((e) => {
        return {
          ...e,
          value: e.cityId,
          label: e.cityName,
        };
      });
      setCities(citiesArr);
    } else {
      setCities([]);
    }
  };

  let handleChangeSelectCountry = (item) => {
    setCities([]);
    if (rCities && rCities.current) rCities.current.clearValue();
    if (item?.value) getCityForCountry(item.value);
  };

  let handleCleanFilters = () => {
    setCountries([]);
    setCities([]);
    setFiltered(false);
    runQueryCountry({
      variables: { clientId: UserComplete.clientId },
      context: { clientName: "LinkUsers" },
    });
  };

  const handleChange = (event, newValue) => {
    if (newValue === 0) selectMenu(["add", "New User"]);
    if (newValue === 1) selectMenu(["history", "User history "]);
    setValue(newValue);
  };

  let handleClickActions = (event, rowData) => {
    setAnchorEl(event.currentTarget);
    setAnchorSelected(rowData.idEvent);
  };

  let handleCloseActions = () => {
    setAnchorEl(null);
    setAnchorSelected(null);
  };

  const handleChangePage = (event, newPage) => {
    if (newPage > page) {
      setshowLoader(true);
      runEventsAfter({
        variables: {
          first: rowsPerPage,
          after: endCursor,
          startDate:
            Filtered && dataFilter.inicialDate ? dataFilter.inicialDate : null,
          finishDate:
            Filtered && dataFilter.finalDate ? dataFilter.finalDate : null,
          countriesId:
            Filtered && dataFilter.country ? [dataFilter.country] : [],
          citiesId: Filtered && dataFilter.city ? [dataFilter.city] : [],
          categoryId:
            Filtered && dataFilter.category ? dataFilter.category : null,
          searchBy: Filtered && searchText ? searchText : null,
          eventType:
            Filtered && dataFilter.eventType ? dataFilter.eventType : null,
        },
      });
    }
    if (newPage < page) {
      setshowLoader(true);
      runEventsBefore({
        variables: {
          last: rowsPerPage,
          before: startCursor,
          startDate:
            Filtered && dataFilter.inicialDate ? dataFilter.inicialDate : null,
          finishDate:
            Filtered && dataFilter.finalDate ? dataFilter.finalDate : null,
          countriesId:
            Filtered && dataFilter.country ? [dataFilter.country] : [],
          citiesId: Filtered && dataFilter.city ? [dataFilter.city] : [],
          categoryId:
            Filtered && dataFilter.category ? dataFilter.category : null,
          searchBy: Filtered && searchText ? searchText : null,
          eventType:
            Filtered && dataFilter.eventType ? dataFilter.eventType : null,
        },
      });
    }
    // setReloadSurveyList(!reloadSurveyList)
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value ? parseInt(event.target.value) : 5);
    setPage(0);
    setshowLoader(true);
    runEventsFirst({
      variables: {
        first: event.target.value ? parseInt(event.target.value) : 5,
        startDate:
          Filtered && dataFilter.inicialDate ? dataFilter.inicialDate : null,
        finishDate:
          Filtered && dataFilter.finalDate ? dataFilter.finalDate : null,
        countriesId: Filtered && dataFilter.country ? [dataFilter.country] : [],
        citiesId: Filtered && dataFilter.city ? [dataFilter.city] : [],
        categoryId:
          Filtered && dataFilter.category ? dataFilter.category : null,
        searchBy: Filtered && searchText ? searchText : null,
        eventType:
          Filtered && dataFilter.eventType ? dataFilter.eventType : null,
      },
    });
  };

  let updateState = (rowData, state) => {
    setshowLoader(true);
    updateStatusevent({
      variables: {
        eventid: rowData.idEvent,
        newState: state,
      },
    }).then((response) => {
      setshowLoader(false);
      if (response.data.eventChangeState.idEvent) {
        if (state === "Deleted") {
          data?.splice(
            data.findIndex((f) => f.idEvent === rowData.idEvent),
            1
          );
        } else {
          rowData.eventState = state;
        }
        setreloadRender(!reloadRender);
      }
    });
  };

  const handleEditEvent = (rowData) => {
    history?.push({
      pathname: `/ManageEvent`,
      state: { idEvent: rowData.idEvent, path: `/EventManager` },
    });
  };

  const handleCreateSurveyFromTemplate = (event) => {
    setEventSelected(event);
    setShowTemplates(true);
    setTemplateToPreview();
  };

  const handleRatingDownload = (event) => {
    setnameFile("Event_Ratings_" + event.idEvent);
    setDataExport(event.feedbacks);
  };

  const handleOpenTemplate = (template) => {
    setTemplateToPreview({ ...template });
  };

  const handleUseTemplate = (template) => {
    setshowLoader(true);
    createSurveyForEvent({
      variables: {
        guestList: eventSelected?.guestUsers,
        surveyName: eventSelected?.eventName,
        surveyDescription: eventSelected?.eventName,
      },
    })
      .then((response) => {
        if (response?.data?.createSurveyForWellnessEvent?.outputData) {
          let surveyId = response.data.createSurveyForWellnessEvent.outputData;
          let templateId = template.id;
          let promiseJoinEvent = joinEventWithSurvey({
            variables: {
              eventId: eventSelected?.idEvent,
              surveyId: surveyId,
            },
          });
          let promiseApplyTemplate = applyTemplate({
            variables: {
              templateId: templateId,
              surveyId: surveyId,
            },
          });
          Promise.all([promiseApplyTemplate, promiseJoinEvent])
            .then((res) => {
              setshowLoader(false);
              history.push({
                pathname: `/ManageSurvey`,
                state: { idSurvey: surveyId, path: `/ManageSurvey` },
              });
            })
            .catch((error) => {
              setshowLoader(false);
              const errorMessage = error.message.split("\n")[0];
              NotificationManager.error(errorMessage, "", 5000);
            });
        }
      })
      .catch((error) => {
        setshowLoader(false);
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  const handleSeeDetails = (rowData) => {
    history.push({
      pathname: `/DetailEvent`,
      state: {
        idEvent: rowData.idEvent,
        event: rowData,
        path: `/EventManager`,
      },
    });
  };

  let toggleChecked = (rowData) => {
    updateState(
      rowData,
      rowData.eventState.toUpperCase() == "ACTIVE" ? "Inactive" : "Active"
    );
  };

  let FilterEvents = () => {
    setFiltered(true);
    setPage(0);
    runEventsFirst({
      variables: {
        first: rowsPerPage,
        startDate: dataFilter.inicialDate ? dataFilter.inicialDate : null,
        finishDate: dataFilter.finalDate ? dataFilter.finalDate : null,
        countriesId: dataFilter.country ? [dataFilter.country] : [],
        citiesId: dataFilter.city ? [dataFilter.city] : [],
        categoryId: dataFilter.category ? dataFilter.category : null,
        searchBy: searchText ? searchText : null,
        eventType: dataFilter.eventType ? dataFilter.eventType : null,
      },
    });
  };

  useEffect(() => {
    FilterEvents();
  }, [searchText]);

  const getDataBySearch = () => {
    setSearchText(rSearch?.current?.value);
  };

  const applySearchOnBreak = () => {
    let timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(() => {
        getDataBySearch();
      }, 500);
    };
  };

  const handleSearch = applySearchOnBreak();

  let deleteSurvey = (rowData) => {
    updateState(rowData, "Deleted");
    setOpenDeleteModal(null);
  };

  const showDeleteModal = () => {
    return openDeleteModal ? (
      <ModalConfirmAction
        title={"Are you sure you want to delete this event?"}
        open={openDeleteModal}
        setOpen={setOpenDeleteModal}
        fn={deleteSurvey}
      />
    ) : null;
  };

  let handleGuests = (item) => {
    history.push({
      pathname:
        item.eventType == "Public"
          ? `/AdminPublicGuestsContainer`
          : `/AdminPrivateGuestsContainer`,
      state: {
        idEvent: item.idEvent,
        nameEvent: item.eventName,
        startDate: item.startDate,
        path: "/EventManager",
        event: item,
      },
    });
  };

  let showSelectedMenu = () => {
    switch (selectedMenu[0]) {
      case "add":
        return (
          <>
            <ActionSection style={{ marginLeft: "1rem" }}>
              <Col className="mt-3">
                <Card
                  colorBorder="#FFFFFF"
                  coloricon="#FFFFFF"
                  code="new-event"
                  title="New Event"
                  icon="plus"
                  subtitle="New Event"
                  footerText="New event"
                  setFormTrigger={setFormTrigger}
                />
              </Col>
              <Col className="mt-2">
                <div className="right-section">
                  <div style={{ margin: "0 10px" }}>
                    <Tooltip title="Filters">
                      <TableViewButton
                        iconColor={showFilter}
                        onClick={() => setShowFilter(!showFilter)}
                        className="MuiButtonBase-root MuiIconButton-root"
                      >
                        <span
                          style={{ width: "fit-content" }}
                          className="MuiIconButton-label"
                        >
                          <FilterList className="filter-list-icon" />
                        </span>
                      </TableViewButton>
                    </Tooltip>
                  </div>
                  <SearchComponent
                    rSearch={rSearch}
                    handleSearch={handleSearch}
                    setSearchText={setSearchText}
                  />
                  <div className="table-action">
                    <Tooltip title="View List">
                      <TableViewButton
                        iconColor={showCards}
                        onClick={() => setShowCards(false)}
                        className="MuiButtonBase-root MuiIconButton-root"
                      >
                        <span
                          style={{ width: "fit-content" }}
                          className="MuiIconButton-label"
                        >
                          <ViewList className="list-view" />
                        </span>
                      </TableViewButton>
                    </Tooltip>
                    <Tooltip title="View Cards">
                      <TableViewButton
                        iconColor={showCards}
                        onClick={() => setShowCards(true)}
                        style={{ borderLeft: "none" }}
                        className="MuiButtonBase-root MuiIconButton-root"
                      >
                        <span
                          style={{ width: "fit-content" }}
                          className="MuiIconButton-label"
                        >
                          <ViewCards className="card-view" />
                        </span>
                      </TableViewButton>
                    </Tooltip>
                  </div>
                </div>
              </Col>
            </ActionSection>
            {showFilter && (
              <ContentFilters>
                <AdminEventsFilters
                  countries={countries}
                  cities={cities}
                  categoriesList={categoriesList}
                  setDataFilter={setDataFilter}
                  handleChangeSelectCountry={handleChangeSelectCountry}
                  handleCleanFilters={handleCleanFilters}
                  FilterEvents={FilterEvents}
                  rCities={rCities}
                ></AdminEventsFilters>
              </ContentFilters>
            )}
            <DetailContainer>
              <Row>
                <Col md={12} style={{ padding: "0" }}>
                  {loadingEvents ? (
                    <div
                      style={{
                        height: "25vh",
                        margin: "auto",
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      <PointersLine color={themeConfig.text.primary} />
                    </div>
                  ) : null}
                  {!loadingEvents && (
                    <ContentTable>
                      {!showCards && (
                        <MaterialTable
                          style={{
                            position: "relative",
                            padding: "0 20px 0 26px",
                            marginLeft: "0",
                            width: "100%",
                            marginBottom: "0",
                          }}
                          title=""
                          columns={[
                            {
                              title: "Event ID",
                              field: "idEvent",
                              type: "string",
                            },
                            {
                              title: "Name",
                              field: "eventName",
                              type: "string",
                              render: (rowData) =>
                                rowData && (
                                  <Tooltip title={rowData.eventName} arrow>
                                    <div>
                                      {rowData.eventName.length > 17
                                        ? rowData.eventName.substring(0, 17) +
                                        "..."
                                        : rowData.eventName}
                                    </div>
                                  </Tooltip>
                                ),
                            },
                            {
                              title: "Category",
                              field: "categoryName",
                              type: "string",
                            },
                            {
                              title: "Event Date",
                              field: "startDateFormatted",
                              type: "string",
                            },
                            {
                              title: "Duration",
                              field: "duration",
                              type: "string",
                            },
                            {
                              title: "Creator",
                              field: "createUser",
                              type: "string",
                              render: (rowData) =>
                                rowData && (
                                  <Tooltip title={rowData.createUser} arrow>
                                    <div>
                                      {rowData.createUser.length > 17
                                        ? rowData.createUser.substring(0, 17) +
                                        "..."
                                        : rowData.createUser}
                                    </div>
                                  </Tooltip>
                                ),
                            },
                            {
                              title: "Type",
                              field: "eventType",
                              type: "string",
                            },
                            {
                              title: "Guests",
                              field: "internal_action",
                              type: "string",
                              render: (rowData) => {
                                return (
                                  <ContentRegistered>
                                    {rowData.guests}
                                    <ChevronRight
                                      onClick={() => handleGuests(rowData)}
                                    />
                                  </ContentRegistered>
                                );
                              },
                            },
                            {
                              title: "Confirmed People",
                              field: "confirmed",
                              type: "string",
                              cellStyle: {
                                padding: "0px 21px",
                              },
                              headerStyle: {
                                padding: "0px",
                              },
                              render: (rowData) => (
                                <PercentLabel value={rowData.confirmed}>
                                  {rowData.confirmed + "%"}
                                </PercentLabel>
                              ),
                            },
                            /*{
                        title: 'State',
                        field: 'eventState',
                        type: 'string',
                        cellStyle: {
                          padding: '0px 13px',
                        },
                        headerStyle: {
                          padding: '0px',
                        },
                        render: (rowData) => {
                          return (
                            <Tooltip
                              title={
                                rowData?.eventState === 'Inactive'
                                  ? 'Disable'
                                  : 'Active'
                              }
                            >
                              <div
                                className="point"
                                style={{
                                  background: `${
                                    rowData?.eventState === 'Inactive'
                                      ? 'rgba(191, 191, 191, 1)'
                                      : 'rgba(4, 180, 105, 1)'
                                  }`,
                                  height: '1em',
                                  width: '1em',
                                  borderRadius: '7px',
                                }}
                              ></div>
                            </Tooltip>
                          )
                        },
                      },*/
                            {
                              title: "See Detail",
                              field: "detail",
                              sorting: false,
                              type: "string",
                              render: (rowData) =>
                                rowData && (
                                  <ContentButtonSeeDetails>
                                    <button
                                      onClick={() => handleSeeDetails(rowData)}
                                    >
                                      <ArrowForwardIcon />
                                    </button>
                                  </ContentButtonSeeDetails>
                                ),
                            },
                            {
                              title: "Actions",
                              field: "internal_action",
                              sorting: false,
                              cellStyle: {
                                padding: "0px 6px",
                              },
                              headerStyle: {
                                padding: "0px",
                              },
                              render: (rowData) =>
                                rowData && (
                                  <ActionsContainer>
                                    <FormControlLabel
                                      control={
                                        <AntSwitch
                                          size="small"
                                          // disabled={
                                          //   rowData?.eventState.toUpperCase() === "ACTIVE"
                                          //     ? false
                                          //     : true
                                          // }
                                          checked={
                                            rowData?.eventState.toUpperCase() ===
                                              "ACTIVE"
                                              ? true
                                              : false
                                          }
                                          onChange={() =>
                                            toggleChecked(rowData)
                                          }
                                        />
                                      }
                                    />
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Tooltip title="Actions">
                                        <IconButton
                                          aria-label="more"
                                          aria-controls="long-menu"
                                          aria-haspopup="true"
                                          className={classes.active}
                                          onClick={(e) =>
                                            handleClickActions(e, rowData)
                                          }
                                        >
                                          <MoreVertIcon />
                                        </IconButton>
                                      </Tooltip>
                                      <MenuManageEvents
                                        idManageEvents={rowData.idEvent}
                                        item={rowData}
                                        anchorSelected={anchorSelected}
                                        anchorEl={anchorEl}
                                        setAnchorEl={setAnchorEl}
                                        setAnchorSelected={setAnchorSelected}
                                        handleEditEvent={handleEditEvent}
                                        handleCloseActions={handleCloseActions}
                                        setOpenDeleteModal={setOpenDeleteModal}
                                        handleCreateSurveyFromTemplate={
                                          handleCreateSurveyFromTemplate
                                        }
                                        identity="event-list"
                                      />
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <ClickAwayListener
                                        onClickAway={() => {
                                          if (
                                            openDescription === rowData.idEvent
                                          ) {
                                            setOpenDescription(false);
                                          }
                                        }}
                                      >
                                        <HtmlTooltip
                                          open={
                                            openDescription === rowData.idEvent
                                          }
                                          title={
                                            <>
                                              <div
                                                style={{
                                                  margin: "0",
                                                  listStyleType: "circle",
                                                  lineHeight: "1.3",
                                                  fontSize: "13px",
                                                }}
                                                dangerouslySetInnerHTML={{
                                                  __html: rowData.description,
                                                }}
                                              />
                                            </>
                                          }
                                          placement="left"
                                          arrow
                                        >
                                          <IconButton
                                            onClick={() =>
                                              setOpenDescription(
                                                rowData.idEvent
                                              )
                                            }
                                          >
                                            <InfoIcon
                                              style={{
                                                cursor: "pointer",
                                                color: themeConfig.text.primary,
                                              }}
                                            />
                                          </IconButton>
                                        </HtmlTooltip>
                                      </ClickAwayListener>
                                    </div>
                                  </ActionsContainer>
                                ),
                            },
                          ]}
                          data={data}
                          options={{
                            maxBodyHeight: 450,
                            paging: false,
                            search: false,
                            toolbar: false,
                            headerStyle: {
                              fontWeight: "bold",
                            },
                            cellStyle: {
                              padding: "5px 10px",
                            },
                          }}
                        ></MaterialTable>
                      )}
                      {showCards && (
                        <>
                          <ViewControlMenu
                            className="mt-5 d-flex"
                            identity={"event-list"}
                            title={""}
                            showCards={showCards}
                            setShowCards={setShowCards}
                            list={data}
                            isAgent={false}
                            toggleChecked={toggleChecked}
                            handleClickActions={handleClickActions}
                            anchorSelected={anchorSelected}
                            anchorEl={anchorEl}
                            handleCloseActions={handleCloseActions}
                            handleEditEvent={handleEditEvent}
                            handleSeeDetails={handleSeeDetails}
                            handleGuests={handleGuests}
                            setAnchorEl={setAnchorEl}
                            setAnchorSelected={setAnchorSelected}
                            setOpenDeleteModal={setOpenDeleteModal}
                            style={{ display: "block", height: "fit-content" }}
                            handleCreateSurveyFromTemplate={
                              handleCreateSurveyFromTemplate
                            }
                            handleRatingDownload={handleRatingDownload}
                          />
                        </>
                      )}
                      {!loadingEvents && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "0 20px 0 26px",
                            marginTop: "1rem",
                          }}
                        >
                          <Convention>
                            <div
                              style={{
                                background: "rgba(191, 191, 191, 1)",
                                height: "1em",
                                width: "1em",
                                borderRadius: "7px",
                              }}
                            ></div>
                            <p>Disable</p>
                            <div
                              style={{
                                background: "rgba(4, 180, 105, 1)",
                                height: "1em",
                                width: "1em",
                                borderRadius: "7px",
                              }}
                            ></div>
                            <p>Active</p>
                          </Convention>
                          <TablePagination
                            hidden={
                              !allPages && !rowsPerPage && !rowsPerPageOptions
                            }
                            component="div"
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              width: "100%",
                            }}
                            count={allPages}
                            page={page}
                            onPageChange={handleChangePage}
                            rowsPerPage={rowsPerPage}
                            rowsPerPageOptions={rowsPerPageOptions}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                          />
                        </div>
                      )}
                    </ContentTable>
                  )}
                </Col>
              </Row>
            </DetailContainer>
          </>
        );
      case "history":
        return (
          <>
            <AdminCategoryContainer />
          </>
        );
      default:
        break;
    }
  };

  useEffect(() => {
    if (formTrigger === "new-event") {
      history?.push({
        pathname: `/ManageEvent`,
        state: { path: `/EventManager` },
      });
    }
  }, [formTrigger]);

  useEffect(() => {
    if (formTrigger !== selectedMenu[0]) {
      setFormTrigger("");
    }
  }, [selectedMenu]);

  useEffect(() => {
    runQueryCountry({
      variables: { clientId: UserComplete.clientId },
      context: { clientName: "LinkUsers" },
    });
    runQueryGetCategories();
  }, [UserComplete]);

  useEffect(() => {
    if (!Filtered) {
      runEventsFirst({
        variables: {
          first: rowsPerPage,
          startDate: null,
          finishDate: null,
          countriesId: [],
          citiesId: [],
          categoryId: null,
          searchBy: null,
          eventType: null,
        },
      });
    }
  }, [Filtered]);
  return (
    <GeneralStyle style={{ backgroundColor: themeConfig.neutral.white }}>
      <HeaderComponent Icon={CalendarIcon} text={"My calendar"} />
      {loadingCountries || (showLoader && <ModalLoader></ModalLoader>)}
      <Paper square style={{ marginBottom: "17px" }}>
        <AntTabs className={classes.tabs} value={value} onChange={handleChange}>
          <AntTab label="Events" />
          <AntTab label="Event Categories" />
        </AntTabs>
      </Paper>
      {formTrigger === "" && (
        <>
          <CardsWrapperUsers>{showSelectedMenu()}</CardsWrapperUsers>
        </>
      )}
      {showDeleteModal()}
      {dataExport && (
        <ExportExcelFile
          data={dataExport}
          nameFile={nameFile}
        ></ExportExcelFile>
      )}
      {showTemplates && (
        <PortalModal>
          <ModaContainer>
            <ModalContent>
              <TemplateContainer>
                <TemplateList handleOpen={handleOpenTemplate} />
              </TemplateContainer>
              <PreviewContainer>
                <ModalTemplatePreview
                  template={templateToPreview}
                  setModalVisibility={() => {
                    setShowTemplates(false);
                  }}
                  handleApplyTemplate={handleUseTemplate}
                />
              </PreviewContainer>
            </ModalContent>
          </ModaContainer>
        </PortalModal>
      )}
    </GeneralStyle>
  );
};
export default AdminEventsContainer;
